<template>
  <el-card class="v_kefu_list">
    <div class="g-flex"  slot="header">
      <span>顾客列表</span>
      <!-- <div class="g-flex-justify-end g-flex-1">
        <el-button v-if="auth.saveEnt" size="mini" type="success" @click="setForm()">新增客服</el-button>
      </div> -->
    </div>
    <!-- 搜索 -->
    <el-form :inline="true" size="mini" :model="query">
      <el-form-item>
        <el-select slot="label" v-model="query.search_key" placeholder="查询">
          <el-option label="唯一标识" value="client_id"></el-option>
          <el-option label="姓名" value="name"></el-option>
          <el-option label="手机号" value="mobile"></el-option>
          <el-option label="邮箱" value="email"></el-option>
          <el-option label="ip" value="ip"></el-option>
          <el-option label="ip地址" value="ip_address"></el-option>
        </el-select>
        <el-row>
          <el-col :span="18">
            <el-input v-model="query.search_val" @keyup.enter.native="getList()" @clear="getList()" placeholder="请输入查找内容" clearable></el-input>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="登录时间">
          <el-date-picker v-model="query.date_time" @change="getList()" type="datetimerange"
                          :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table stripe size="mini" v-loading="table.loading" :data="table.rows" border>
      <!-- <el-table-column prop="id" label="顾客ID" width="80" :show-overflow-tooltip="true"/> -->
      <el-table-column prop="client_id" label="唯一标识" width="80" :show-overflow-tooltip="true"/>
      <!-- <el-table-column v-if="$global.adminUser.type === 4" prop="ent_id" label="企业ID" width="80" :show-overflow-tooltip="true"/> -->
      <el-table-column prop="kefu_name" label="接待客服" width="80" :show-overflow-tooltip="true"/>
      <el-table-column prop="name" label="姓名" width="80" :show-overflow-tooltip="true"/>
      <el-table-column label="头像" width="65" :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <el-image :src="scope.row.avatar" class="v-customer-avator"/>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"/>
      <el-table-column prop="ip" label="ip" width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="ip_address" label="ip地址" :show-overflow-tooltip="true"/>
      <el-table-column prop="browsers" label="浏览器" :show-overflow-tooltip="true"/>
      <el-table-column prop="system" label="系统" :show-overflow-tooltip="true"/>
      <el-table-column prop="mobile" label="手机号" :show-overflow-tooltip="true"/>
      <el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true"/>
      <el-table-column prop="qq" label="qq号" :show-overflow-tooltip="true"/>
      <el-table-column prop="web_title" label="着陆页标题" :show-overflow-tooltip="true"/>
      <el-table-column label="创建时间" width="130" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.create_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>

      <el-table-column label="登录时间" width="130" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.login_time, 'yyyy-MM-dd hh:mm')}}</span>
        </template>
      </el-table-column>

      <el-table-column label="状态" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0" class="g-grey">离线</span>
            <span v-else-if="scope.row.status==1" class="g-green">在线</span>
          </template>
      </el-table-column>

      <el-table-column label="操作" width="130" :show-overflow-tooltip="true" fixed="right" v-if="auth.seeHistory">
        <template slot-scope="scope">
          <span @click="seeChatHistory(scope.row)" class="v-see-history">查看对话</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :page-sizes="[15, 30, 60, 100]" :page-size="query.limit" :total="table.total" :current-page.sync="query.page" @current-change="getList(false)" @size-change="sizeChange" small hide-on-single-page background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    
    <!--新增和编辑-->
    <!-- <el-dialog :title="formData.id?'编辑客服':'新增客服'" :close-on-click-modal="false" :visible.sync="form">
        <el-form :model="formData" label-width="100px">
            <el-form-item v-if="formData.id" label="id">{{formData.id}}</el-form-item>
            <el-form-item label="企业ID" v-if="$global.adminUser.type === 4">
                <el-input v-model="formData.ent_id" autocomplete="off" :disabled="formData.id ? true : false"></el-input>
            </el-form-item>

            <el-form-item label="用户名">
                <el-input v-model="formData.user_name" autocomplete="off" :disabled="formData.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="formData.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input type="password" v-model="formData.password" :placeholder="formData.id?'为空不修改':'请输入密码'" autocomplete="off"></el-input>
            </el-form-item>
             <el-form-item label="备注">
                <el-input v-model="formData.remark" type="textarea" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formData.status">
                    <el-option label="离线" :value="0"></el-option>
                    <el-option label="在线" :value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="form = false">取 消</el-button>
            <el-button type="primary" @click="save()">确 定</el-button>
        </div>
    </el-dialog> -->
    
    <!-- 历史对话 -->
    <customer-chat-history ref="CustomerChatHistory"/>
  </el-card>
</template>

<script>
  import { formatDate } from '@/utils/index.js';
  import { apiGetCustomerList, apiSaveKefu, apiDelKefu } from '@/utils/api.js'
  import CustomerChatHistory from '@/views/customer/CustomerChatHistory.vue'
  export default {
    components: { CustomerChatHistory },
    data() {
      return {
        auth:{
          saveEnt: this.$global.ApiList.includes(31),
          delEnt: this.$global.ApiList.includes(32),
          seeHistory: this.$global.ApiList.includes(58)
        },

        query: { search_key: 'client_id', date_time: [], search_val: '', page:1, limit: 15 ,},

        table:{ loading:false, total:0, rows:[] },

        form: false,
        
        formData: {},
      }
    },
    created() {
      this.getList()
    },
    methods: {
      formatDate,

      // 查看对话
      seeChatHistory(params) {
        this.$refs.CustomerChatHistory.onShow(params)
      },

      // 获取列表
      async getList(pageInit = true) {
        if (pageInit) this.query.page = 1
        this.table.loading = true
        const { success, data } = await apiGetCustomerList(this.query)
        this.table.loading = false
        this.table.rows = data.rows
        this.table.total = data.total
        if(!success) return
      },

      //每页数量改变
      sizeChange(limit) {
        this.query.limit = limit
        this.getList()
      },

      //设置form
      setForm(formData = { status:0 }) {
        this.formData = Object.assign({}, formData)
        this.form = true
      },

      // 点击保存
      async save() {
        const loading = this.$loading()
        const { success, data } = await apiSaveKefu(this.formData)
        loading.close()
        if(!success) return
        this.$message.success(data.msg)
        this.form = false
        this.getList()
      },

      // 点击删除
       del({ id }) {
        this.$confirm('将永久删除该用户, 是否继续?', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.table.loading = true
          const { success, data } = await apiDelKefu({ id: id })
          this.table.loading = false
          if(!success) return
          this.$message.success(data.msg)
          this.getList()
        }).catch(()=>{})
      }, 
      
    }
  }
</script>

<style lang="scss">
.v_kefu_list {
  .v-customer-avator {
    width: 40px;
    height: 40px;
    object-fit: cover;
  }
  .v-see-history {
    color: $mainBlue;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>